import { render, staticRenderFns } from "./skuEdit.vue?vue&type=template&id=aea2ae38&"
import script from "./skuEdit.vue?vue&type=script&lang=js&"
export * from "./skuEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports